import axios from "axios";
import { captureException } from "@sentry/react";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

export async function addHistoryAPI(accessJWT: string, data: any, method: "POST" | "PUT", signal?: any) {
  const URL = `${ENDPOINT}/app/v1/users/history`;
  let tempSignal = signal;
  if (!signal) tempSignal = null;
  let config = getHeaderConfig(tempSignal, accessJWT);
  let body = {
    ...data,
  };
  if (!hasUsableJWT(accessJWT, "addHistoryAPI")) return null;
  try {
    let response: any = null;
    if (method === "POST") response = await axios.post(URL, encryptData(body), config);
    else response = await axios.put(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } else return null;
    // return response?.data;
  } catch (error) {
    // Previously the catch was empty → every save failure (413 on large chats,
    // 5xx, network blip, expired JWT) was invisible (no Sentry, no log), which is
    // why prod save bugs couldn't be traced. Report it (ignore user-cancelled
    // aborts) and return null explicitly so callers see a definite failure.
    if (!axios.isCancel?.(error)) {
      captureException(error, { tags: { area: "saveHistory" }, extra: { method } });
    }
    return null;
  }
}
